import Tab from '@material-ui/core/Tab'
import Tabs from '@material-ui/core/Tabs'
import { LocationProps } from '@reach/router'
import { TFunction } from 'i18next'
import React, { useEffect, useState } from 'react'
import { withTranslation } from 'react-i18next'
import ContactUsDropdown from '../components/contactUsDropdown'
import ContactUsTab from '../components/contactUsTab'
import PrivacyTab from '../components/privacyTab'
import SEO from '../components/seo'
import TabPanel from '../components/tabs'
import TermsTab from '../components/termsTab'
import Layout from '../layouts/defaultLayout'
import { styles } from '../pagesStyles/companyStyles'
import ContentContainer from './../components/contentContainer'

interface CompanyPageProps {
  t: TFunction
  location: LocationProps
}

const tabsNames = {
  privacy: 'privacy',
  terms: 'terms',
  contactUs: 'contact-us',
  accountDeletion: 'account-deletion',
}

const getPageUrl = (hashLocation: string) => {
  return hashLocation.split('#')[1]
}
const CompanyPage = ({ t, location }: CompanyPageProps) => {
  const classes = styles()

  const [tabValue, setTabValue] = useState(0)

  useEffect(() => {
    // check hash value in page url
    const pageUrl = getPageUrl(location.hash)
    if (pageUrl === tabsNames.privacy || pageUrl === tabsNames.accountDeletion)
      setTabValue(2)
    else if (pageUrl === tabsNames.terms) setTabValue(1)
    else setTabValue(0)

    // scroll page up when navigating
    window.scrollTo(0, 0)
  }, [location])

  const handleChange = (event: React.ChangeEvent<{}>, newValue: number) => {
    setTabValue(newValue)
  }

  const isAccountDeletion =
    getPageUrl(location.hash) === tabsNames.accountDeletion

  const isContactTab = tabValue === 0

  return (
    <Layout>
      <SEO
        title={isContactTab ? t('seo.contact.title') : t('company.metaTitle')}
        description={
          isContactTab
            ? t('seo.contact.description')
            : t('company.metaDescription')
        }
        keywords={t('seo.contact.keywords')}
      />
      <section className={classes.tabsSection}>
        <ContentContainer>
          <ContactUsDropdown switchTab={handleChange} />
          <Tabs
            className={classes.tabs}
            value={tabValue}
            onChange={handleChange}
            aria-label="company tabs"
            variant="fullWidth"
            // indicatorColor="transparent"
          >
            <Tab
              classes={{
                root: classes.root,
                selected: classes.selected,
              }}
              label={t('company.contactUs')}
            />
            <Tab
              classes={{
                root: classes.root,
                selected: classes.selected,
              }}
              label={t('company.terms')}
            />
            <Tab
              classes={{
                root: classes.root,
                selected: classes.selected,
              }}
              label={t('company.privacy')}
            />
          </Tabs>
        </ContentContainer>
        <ContentContainer>
          <TabPanel value={tabValue} index={0}>
            <ContactUsTab />
          </TabPanel>

          <TabPanel value={tabValue} index={1}>
            <TermsTab />
          </TabPanel>

          <TabPanel value={tabValue} index={2}>
            <PrivacyTab isAccountDeletion={isAccountDeletion} />
          </TabPanel>
        </ContentContainer>
      </section>
    </Layout>
  )
}

export default withTranslation()(CompanyPage)
